import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button, Modal } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';

import styles from './StateErrorModal.module.css';
import { useCurrentStep } from '../../../hooks/useCurrentStep';
import { TStateUpdateErrorDE, TStateUpdateErrorUK } from '../../../types';

type TProps = {
  handleClose: () => void;
  stateError: TStateUpdateErrorUK | TStateUpdateErrorDE;
};

const StateErrorModal = ({ stateError, handleClose }: TProps) => {
  const { t } = useLingui();
  const currentStep = useCurrentStep();

  useEffect(() => {
    if (!stateError) return;

    tracking.ampli.submitStateErrorModalViewed({
      'Step name': currentStep,
      'Errored field': stateError,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateError]);

  if (!stateError) return null;

  return (
    <Modal
      className={styles.modalContainer}
      isOpen
      onClose={handleClose}
      title={t`We have experienced an unexpected error`}
      closeIcon
    >
      {stateError !== 'other' && (
        <>
          <p className={styles.errorMessage}>
            <Trans>Please double check the details entered for:</Trans>
          </p>
          <p className={styles.erroredField}>“{stateError}”</p>
        </>
      )}
      <p className={styles.errorMessage}>
        <Trans>
          If you continue to see this error, please{' '}
          <a
            href={t`mailto:support@iwoca.co.uk`}
            data-testid="email-link"
            target="_blank"
            rel="noreferrer"
          >
            email
          </a>{' '}
          or{' '}
          <a
            href={t`tel:02037780105`}
            data-testid="call-link"
            target="_blank"
            rel="noreferrer"
          >
            call
          </a>{' '}
          our team.
        </Trans>
      </p>
      <Button
        type="button"
        className={styles.closeButton}
        onClick={handleClose}
      >
        <Trans>Close</Trans>
      </Button>
    </Modal>
  );
};

export default StateErrorModal;
